import React from 'react';
import { CheckSquare } from 'lucide-react';

interface MarkAllDoneModalProps {
    remainingCount: number;
    onConfirm: () => void;
    onCancel: () => void;
}

/**
 * Modal for confirming marking all remaining components as done
 */
export const MarkAllDoneModal: React.FC<MarkAllDoneModalProps> = ({
    remainingCount,
    onConfirm,
    onCancel
}) => {
    return (
        <>
            <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onMouseDown={(e) => {
                    if (e.target === e.currentTarget) {
                        onCancel();
                    }
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                <CheckSquare size={20} className="me-2 text-success" />
                                Markera alla som klara
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onCancel}
                                aria-label="Stäng"
                            />
                        </div>
                        <div className="modal-body">
                            <p>
                                Är du säker på att du vill markera alla återstående{' '}
                                <strong>{remainingCount}</strong> komponenter som klara?
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onCancel}
                            >
                                Avbryt
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={onConfirm}
                            >
                                <CheckSquare size={16} className="me-2" />
                                Markera alla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};
